import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppEventService } from 'pumpcalc-core';
import { Errors } from '../validation.service';

@Component({
  selector: 'app-pumpset-form',
  templateUrl: './pumpset-form.component.html',
  styleUrls: ['./pumpset-form.component.css']
})
export class PumpsetFormComponent implements OnInit, OnChanges {

  @Input() pumpSet;
  @Input() errors={};
  name;
  error=Errors;
  showHistory=false;

  constructor(private appEventService:AppEventService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.name=this.pumpSet.name;
  }

  ngOnInit(): void {
  }

  doSave(){
    this.appEventService.emit({name:"SAVE",context:"",data:null});
  }


}
